<template>
  <div class="available-days-schedule">
    <label>{{ $t('settingsOrdering.available_days') }}</label>
    <div
      class="row available-days-schedule__day"
      v-for="(day, dayIdx) in availableDays"
      :key="day.day || dayIdx"
    >
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3 padd in-inline-160">
            <div class="checkbox">
              <input
                type="checkbox"
                v-model="day.open"
                :name="namePrefix + 'days'"
                :id="namePrefix + day.day"
                :disabled="disabled"
              />
              <label :for="namePrefix + day.day">{{ $t('days.' + day.day) | capitalize }}</label>
            </div>
          </div>
          <div class="col-md-9 padd">
            {{ $t('menuLink.from') }}
            <el-time-select
              :disabled="!day.open || disabled"
              placeholder="Select time"
              v-model="day.open_from"
              :picker-options="pickerOptions"
            />
            {{ $t('menuLink.to') }}
            <el-time-select
              :disabled="!day.open || disabled"
              placeholder="Select time"
              v-model="day.open_to"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
        <div class="row intervals" v-if="day.intervals">
          <div
            v-for="(interval, intervalKey) in day.intervals"
            :key="'interval-' + day.day + '-' + intervalKey"
            class="row"
          >
            <div class="col-md-3 padd in-inline-160"></div>
            <div class="col-md-9 padd">
              {{ $t('menuLink.from') }}
              <el-time-select
                :disabled="!day.open || disabled"
                placeholder="Select time"
                v-model="interval.open_from"
                :picker-options="pickerOptions"
              />
              {{ $t('menuLink.to') }}
              <el-time-select
                :disabled="!day.open || disabled"
                placeholder="Select time"
                v-model="interval.open_to"
                :picker-options="pickerOptions"
              />
              <button
                class="btn btn-simple btn-icon"
                :disabled="disabled"
                @click.prevent="deleteInterval(dayIdx, intervalKey)"
              >
                <i :title="$t('general.delete')" class="ti-close text-danger"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <button
          class="btn add mar-to-15"
          :disabled="disabled"
          @click.prevent="addInterval(dayIdx)"
          :title="$t('general.add')"
        >
          <img src="/static/img/icons/add.png">
          {{ $t('general.add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { TimeSelect } from 'element-ui'

  export default {
    name: 'AvailableDaysSchedule',
    components: {
      [TimeSelect.name]: TimeSelect
    },
    props: {
      availableDays: {
        type: Array,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      namePrefix: {
        type: String,
        default: 'schedule-'
      }
    },
    data () {
      return {
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        }
      }
    },
    methods: {
      addInterval (dayIdx) {
        const day = this.availableDays[dayIdx]
        if (!day) return
        if (!day.hasOwnProperty('intervals')) {
          Vue.set(day, 'intervals', [])
        }
        const index = day.intervals.length
        Vue.set(day.intervals, index, {
          open_from: '',
          open_to: ''
        })
      },
      deleteInterval (dayIdx, intervalKey) {
        const day = this.availableDays[dayIdx]
        if (!day || !day.intervals) return
        day.intervals.splice(intervalKey, 1)
      }
    }
  }
</script>

<style scoped>
  .available-days-schedule__day {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/AvailableDaysSchedule.vue